import React from 'react'

/** Renders `**bold**` markers as strong text (tenant help + CMS). */
export function BoldText({ text }) {
  if (!text) return null
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={i} className="font-semibold text-slate-800">
          {part.slice(2, -2)}
        </strong>
      )
    }
    return <span key={i}>{part}</span>
  })
}
